export default __webpack_public_path__ + "static/media/black_bishop.e4b64d76.png";